import { useEffect, useRef } from "react";

/**
 * Run `cancel` when the panel closes (`isOpen` true -> false). The messages tab stays mounted
 * while the panel is closed, so anything that holds a device (the microphone of a voice
 * recording) must be released explicitly or it keeps recording behind a closed panel. The
 * recording (or an un-sent stopped preview) is DISCARDED, not saved or sent; no toast is shown
 * because the panel is already closed (documented in the changeset).
 */
export function useCancelWhenClosed(isOpen: boolean, cancel: () => void): void {
  const cancelRef = useRef(cancel);
  cancelRef.current = cancel;
  const wasOpen = useRef(isOpen);
  useEffect(() => {
    if (wasOpen.current && !isOpen) cancelRef.current();
    wasOpen.current = isOpen;
  }, [isOpen]);
}
